
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/co-ownership",
      function () {
        return require("private-next-pages/co-ownership.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/co-ownership"])
      });
    }
  